<form [formGroup]="primaryForm" (ngSubmit)="create()">
    <div class="card">
        <div class="card-header text-center" style="text-transform: uppercase;">AGREGAR TAGS NFC <i class="fa-solid fa-mobile"></i></div>
        <div class="card-body">
            <div class="row gx-3 mb-3">
                <div class="col-md-6">
                    <label class="small mb-1" for="identification">CÓDIGO</label>
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="basic-addon1">
                            <i class="fa-solid fa-sim-card"></i>
                        </span>
                        <input  type="text" class="form-control" formControlName="code">
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="small mb-1" for="serie">Nombre *</label>
                    <div class="input-group">
                        <span class="input-group-text">
                            <i class="fa-brands fa-nfc-symbol"></i>
                        </span>
                        <input type="text" class="form-control text-capitalize" formControlName="tag">
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="small mb-1" for="serie">Instalación</label>
                    <select class="form-select form-control" formControlName="facility_id">
                        <option [value]="0">TODAS</option>
                        <option *ngFor="let item of facilityes" [value]="item?.id">{{item?.name | uppercase}}</option>
                    </select>
                </div>
                <div class="col-md-6">
                    <label class="small mb-1" for="location">UBICACIÓN </label>
                    <div class="input-group">
                        <span class="input-group-text"><i class="fa-solid fa-location-dot"></i></span>
                        <input type="text" class="form-control text-capitalize" formControlName="location">
                    </div>
                </div>
            </div>
            <button class="btn btn-primary w-100" type="submit">CREAR</button>
        </div>
    </div>
</form>
